export const brandValues = {
    B2B: {
        EMAILS: {
            INFO: 'info@ultimatejetvacations.com',
            COMMISSIONS: 'commissions@ultimatejetvacations.com',
            AIR: 'air@ultimatejetvacations.com',
            INSURANCE: 'congierge@ultimatejetvacations.com',
            SERVICE: 'congierge@ultimatejetvacations.com',
            BOOK_OPTION: 'congierge@ultimatejetvacations.com',
        },
    },
    B2C: {
        EMAILS: {
            INFO: 'info@luxuriavacations.com',
            COMMISSIONS: 'commissions@luxuriavacations.com',
            AIR: 'air@luxuriavacations.com',
            INSURANCE: 'congierge@luxuriavacations.com',
            SERVICE: 'congierge@luxuriavacations.com',
            BOOK_OPTION: 'congierge@luxuriavacations.com',
        },
    },
};
